import task from './task'

const apiBusinesses = {
  'get-list': {
    method: 'post',
    url: '/admincp/business/list'
  },
  getById: {
    method: 'get',
    url: '/admincp/business/ID'
  },
  delete: {
    method: 'delete',
    url: '/admincp/business'
  },
  archive: {
    method: 'delete',
    url: '/admincp/business/archive'
  },
  restore: {
    method: 'put',
    url: '/admincp/business/restore'
  },
  add: {
    method: 'post',
    url: '/admincp/business'
  },
  edit: {
    method: 'put',
    url: '/admincp/business/ID'
  },
  select: {
    method: 'get',
    url: '/admincp/business/find?key=KEY'
  },
  selectByNodeTpe: {
    method: 'get',
    url: '/admincp/business/find?key=KEY&nodeType=NODE_TYPE'
  },
  default: {
    method: 'get',
    url: '/admincp/business/create-default'
  },
  getByNodeType: {
    method: 'get',
    url: '/admincp/business/by-node-type?id=ID'
  },
  getByNodeTypeWithTranporation: {
    method: 'get',
    url: '/admincp/business/by-node-type?id=ID&transporation=TRANSPORATION'
  }
}

export default {
  ...apiBusinesses,
  task
}
